import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import React from 'react';
import Header from '../components/Header';

const TemplateWrapper = ({ data, children }) => (
  <div
    style={{
      backgroundImage:
        'linear-gradient(to bottom, rgba(42,183,202,.25) 0%, rgba(255,255,255,1) 50vh)',
      backgroundAttachment: 'fixed',
      minHeight: '100vh',
    }}
  >
    <Helmet>
      <meta name="description" content={data.site.siteMetadata.description} />
      <title>{data.site.siteMetadata.title}</title>
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg?2" color="#448fa3" />
      <link
        href="//fonts.googleapis.com/css?family=Source+Serif+Pro:600|Source+Sans+Pro:400,400i,700&amp;subset=latin-ext"
        rel="stylesheet"
        type="text/css"
      />
      <style>
        {`
          a:hover,
          a:focus {
            text-decoration: underline;
          }
          header a {
            color: #448FA3;
          }
          @media (max-width: 767px) {
            .dn-m {
              display: none !important;
            }
          }
          @media (min-width: 768px) {
            .dn-sm {
              display: none !important;
            }
          }
        `}
      </style>
      <script async src="https://www.googletagmanager.com/gtag/js?id=UA-1789772-56" />
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'UA-1789772-56');
        `}
      </script>
    </Helmet>
    <div
      style={{
        background: 'rgba(255,255,255,.5)',
        padding: '1rem 5%',
      }}
    >
      <Header title={data.site.siteMetadata.title} />
    </div>
    <div
      style={{
        padding: '0 5% 5%',
      }}
    >
      <div
        style={{
          margin: 'auto',
          maxWidth: '35em',
        }}
      >
        {children()}
      </div>
    </div>
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
  data: PropTypes.object.isRequired,
};

export default TemplateWrapper;

export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js